<template lang="pug">
.flag-container
  .image-flag(v-if="imageFlagHero === 'patent-pending' || imageFlagMedia === 'patent-pending'")
    img.flag(
      src='https://assets.roguefitness.com/q_auto/UI/icons/PATENT_PENDING_icon_ebgqlc.png'
      alt='Patent pending product'
      width='85'
      height='19'
    )
  .image-flag(v-else-if="imageFlagHero === 'patented' || imageFlagMedia === 'patented'")
    img.flag(
      src='https://assets.roguefitness.com/q_auto/UI/icons/patented-icon_xymqjc.png'
      alt='Patented product'
      width='60'
      height='19'
    )
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  product?: Record<string, any>
  imageFlagHero?: string
  imageFlagMedia?: string
}>(), {
  product        : () => ({}),
  imageFlagHero  : '',
  imageFlagMedia : '',
})
</script>
